import { render, staticRenderFns } from "./SacMemberForm.vue?vue&type=template&id=97b252fe&scoped=true"
import script from "./SacMemberForm.vue?vue&type=script&lang=js"
export * from "./SacMemberForm.vue?vue&type=script&lang=js"
import style0 from "./SacMemberForm.vue?vue&type=style&index=0&id=97b252fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97b252fe",
  null
  
)

export default component.exports